import React from "react";
import {string_geneConcatenation} from "../functions/stringConcatenation";

import "../gene-section.css";
import Typography from "@mui/material/Typography";
import MappedText from "../../../../../../../../../../study-page/create-study/analysis-page/components/clinical-info/mapText";
import { useTranslation } from "react-i18next";


export function DataList_View(props){
    const { t } = useTranslation();
    let { dataList } = props;

    let title = props.title;
    let label = props.label;



    let data_string = string_geneConcatenation(dataList);
    if(dataList === undefined || dataList.length=== 0)
    {
        return <div className={"geneListBox"}><MappedText text="No Genes to query have been selected yet"/></div>
    }
    else{
        return (
            <div className={"geneListBox"}
                 style={{background: props.color}}>
                {(title!== undefined)
                    ? <Typography variant={"body1"}>{label} (n={dataList.length})</Typography>
                    : null
                }
            <div className={"selectedItems"}>
                {data_string}
            </div>
        </div>)
    }
}